/* v8 ignore start */
import {LottieLayerType} from "@/lib/lottie/layers/lottieLayerType";
import {LottieVisualLayerModel} from "@/lib/lottie/layers/lottieVisualLayerModel";

export class LottiePrecompositionLayerModel extends LottieVisualLayerModel<LottiePrecompositionLayerModel.IJson> {
  public get width(): number {
    return this.json.w;
  }

  public get height(): number {
    return this.json.h;
  }

  public get refId(): string {
    return this.json.refId;
  }
}

export namespace LottiePrecompositionLayerModel {
  /**
   * Precomposition Layer
   * Layer that renders a Precomposition asset
   */
  export interface IJson extends LottieVisualLayerModel.IJson {
    /**
     * Layer type
     */
    ty: LottieLayerType.PreComposition;

    /**
     * ID of the precomp as specified in the assets
     */
    refId: string;

    /**
     * Width of the clipping rect
     */
    w: number;

    /**
     * Height of the clipping rect
     */
    h: number;

    /**
     * [not used]: Add Time Remapping
     */
    // tm: any;
  }
}
/* v8 ignore stop */
